import { useEffect, useState } from 'react';
import { fetchActivityLogs } from '../activityService';
// import { MOCK_ACTIVITIES } from '../constants';

const useActivityState = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const loadPage = async (page = 1, size = 10) => {
    // const offset = (page - 1) * limit;
    try {
      setLoading(true);
      const res = await fetchActivityLogs({ page, size });
      setData(res.logs);
      setTotal(res.total);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch customers', error);
    //   setData(MOCK_ACTIVITIES.activities);
    //   setTotal(MOCK_ACTIVITIES.totalCount);
    } finally {
      setLoading(false);
    }
  };

   useEffect(() => {
    loadPage(pagination.current, pagination.pageSize);
  }, [pagination]);

  const onPaginationChange = (page, pageSize) => {
    setPagination((prev) => {
        // Only reset page to 1 if pageSize has changed
        if (pageSize !== prev.pageSize) {
        return { current: 1, pageSize };
        }
        return { current: page, pageSize };
    });
  };

  return {
    data,
    total,
    loading,
    pagination,
    onPaginationChange
  };
};

export default useActivityState;
